export default [
  {
    key: 'count',
    label: 'Number (In 1000s)',
    default: true
  },
  {
    key: 'percent',
    label: 'Percent'
  }
]
